import type { IconData } from '@stacksjs/iconify-core'

export const cr4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#0000b4\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 75.4h640v322.3H0z\"/><path fill=\"#d90000\" d=\"M0 157.7h640v157.7H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default cr4x3
